/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

var customLY = {
    init: function () {
        $('.selectric-init').selectric(function () {
            $(this).removeClass('selectric-init');
            //$(document).trigger($(this).attr('id') + '-init');
            console.log($(this).attr('id') + '-init');
        });
        this.bindEvents();
    },
    bindEvents: function () {

    }

}
customLY.init();


function syncByMediaId (mediaId) {
    if (!mediaId) return;

    document.querySelectorAll('.color-swatch__radio').forEach(radio => {
        if (radio.dataset.variantFeaturedMedia === mediaId.toString()) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

    const swiperSlide = document.querySelector(`.swiper-slide[data-media-id="${mediaId}"]`);
    if (swiperSlide && swiperSlide.closest('.swiper-initialized')?.swiper) {
        const swiperInstance = swiperSlide.closest('.swiper-initialized').swiper;
        swiperInstance.slideTo(parseInt(swiperSlide.dataset.swiperSlideIndex));
    }

    const galleryImage = document.querySelector(`[data-media-id="${mediaId}"]`);
    if (galleryImage && typeof galleryImage.click === 'function') {
        galleryImage.click();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.color-swatch__item').forEach(swatch => {
        swatch.addEventListener('click', () => {
            const mediaId = swatch.dataset.variantFeaturedMedia;
            syncByMediaId(mediaId);
        });
    });

    document.querySelectorAll('.swiper-slide[data-media-id]').forEach(slide => {
        slide.addEventListener('click', () => {
            const mediaId = slide.dataset.mediaId;
            syncByMediaId(mediaId);
        });
    });
});

document.addEventListener('variant:changed', function (event) {
    const variant = event.detail.variant;
    if (variant.featured_image && variant.featured_image.id) {
        syncByMediaId(variant.featured_image.id);
    }

    const variantMetafieldDataElement = document.getElementById('variant_metafield_data');
    const allVariantMetafieldData = JSON.parse(variantMetafieldDataElement?.textContent || '{}');
    const variantData = allVariantMetafieldData[variant.id.toString()];
    const addToCartButton = document.getElementById('AddToCart');
    const preorderLabelElement = document.querySelector('.product-preorder_label');

    if (variantData?.preorder_label && preorderLabelElement) {
        preorderLabelElement.innerHTML = variantData.preorder_label;
        addToCartButton.querySelector('.product-form__add-button-text').innerHTML = 'Pre-order';
        preorderLabelElement.classList.remove('visually-hidden');
    } else {
        addToCartButton.querySelector('.product-form__add-button-text').innerHTML = 'Add to Cart';
        preorderLabelElement.classList.add('visually-hidden');
    }
});


// change selected slide on variant change

document.addEventListener('variant:changed', function (event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let form = event.target;
    let swiper;

    if (document.querySelector('body').classList.contains('curent-template-collection')) {
        if ($(window).width() < 999) {
            swiper = form.closest('.product-item').querySelector('.swiper-initialized');
            changeSlide(swiper);
        }
    }

    function changeSlide (swiper) {
        const newSlide = swiper.querySelector('[data-image="' + variant.featured_image.id + '"]');
        swiper.swiper.slideTo(newSlide.getAttribute(['data-swiper-slide-index']));
    }
});


// SCRIPT PARA OCULTAR LA FLECHA DE LOS PRODUCT THUMBNAILS AL LLEGAR AL FINAL DEL SCROLL
if (document.querySelector("body").classList.contains("template-product")) {
    const nextButton = document.getElementById("product-media-next-button");
    const prevButton = document.getElementById("product-media-prev-button");
    const thumbnailsList = document.querySelector(".product__thumbnail-list");


    nextButton.style.display = "none";
    prevButton.style.display = "none";

    function handleScroll () {
        const isAtEnd = thumbnailsList.scrollHeight - thumbnailsList.scrollTop === thumbnailsList.clientHeight;

        if (isAtEnd) {
            nextButton.style.display = "none";
        } else {
            nextButton.style.display = "block";
        }

        if (thumbnailsList.scrollTop > 0) {
            prevButton.style.display = "block";
        } else {
            prevButton.style.display = "none";
        }
    }

    thumbnailsList.addEventListener("scroll", handleScroll);

    handleScroll();
}

const addToCart = (body, reload = true) => updateCart('add', body, reload);
const changeCart = (body, reload = true) => updateCart('change', body, reload);
const updateCart = (type, body, reload = true) => {
    const url = type === 'add' ? window.themeVariables.routes.cartAddUrl : window.themeVariables.routes.cartChangeUrl;
    if (reload) {

        body.sections = body.sections || [];
        if (!body.sections.includes("mini-cart")) {
            body.sections.push("mini-cart");
        }
    }

    fetch(`${url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            // this triggers Shopify’s server‑side stock validation
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(() => {
            if (reload) {
                fetch('/cart.js')
                    .then(res => res.json())
                    .then(fullCart => {
                        reloadMiniCart(fullCart);
                    });
            }
        })
        .catch(error => console.error('Error updating cart:', error));
};
const reloadMiniCart = (cartContent) => {
    console.log('called reloadMiniCart');
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartContent }
    }));
};


if (document.querySelector("body").classList.contains("curent-template-cart")) {
    let checkoutButtonIsPreorder = document.querySelector(".cart__checkout-button[data-show-preorder]");

    if (checkoutButtonIsPreorder) {
        console.log('asopdimaspodas')
        checkoutButtonIsPreorder.addEventListener('click', (event) => {
            if (checkoutButtonIsPreorder.hasAttribute('data-show-preorder')) {
                event.preventDefault();

                checkoutButtonIsPreorder.removeAttribute('data-show-preorder');
                checkoutButtonIsPreorder.removeAttribute("aria-controls");
                checkoutButtonIsPreorder.removeAttribute("aria-expanded");
                checkoutButtonIsPreorder.removeAttribute("is");
            }
        });
    }
}


document.addEventListener('variant:changed', function (event) {
    const variant = event.detail.variant; // Gives you access to the whole variant details
    const variantMetafieldDataElement = document.getElementById('variant_metafield_data');
    const allVariantMetafieldData = JSON.parse(variantMetafieldDataElement.textContent || '{}');
    const variantData = allVariantMetafieldData[variant.id.toString()];
    const addToCartButton = document.getElementById('AddToCart')
    const preorderLabelElement = document.querySelector('.product-preorder_label')
    if (variantMetafieldDataElement && variantData.preorder_label) {
        const variantMetafieldDataElement = document.getElementById('variant_metafield_data');
        if (variantMetafieldDataElement) {
            if (variantData.preorder_label && preorderLabelElement) {
                preorderLabelElement.innerHTML = variantData.preorder_label;
            } else {
                preorderLabelElement.innerHTML = "ko";
            }
            addToCartButton.querySelector('.product-form__add-button-text').innerHTML = 'Pre-order';
            preorderLabelElement.classList.remove('visually-hidden');
        }
    } else {
        addToCartButton.querySelector('.product-form__add-button-text').innerHTML = 'Add to Cart';
        preorderLabelElement.classList.add('visually-hidden');

    }
});


const couponParameter = new URLSearchParams(window.location.search).get("coupon");
if (couponParameter) {
    const url = `/discount/${couponParameter}`;
    fetch(url).then(response => {
        console.log(response);
        if (response.ok) {
            if (window.location.pathname === '/cart') {
                fetch(`${window.themeVariables.routes.cartUrl}.js`)
                    .then(response2 => {
                        if (response2.ok) {
                            window.location.href = window.themeVariables.routes.cartUrl;
                        }
                    })
            }
        }
    });
}
// Fix buy buttons and preorder label on product page mobile
document.addEventListener('DOMContentLoaded', () => {
    const buyButtons = document.querySelector('.product-form__buy-buttons');
    const preorderLabel = document.querySelector('.product-preorder_label');

    if (!buyButtons) return;

    const MOBILE_BREAKPOINT = 768;
    let buyButtonsOffsetTop = 0;

    function isMobile () {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function setOffset () {
        const rect = buyButtons.getBoundingClientRect();
        buyButtonsOffsetTop = rect.top + window.scrollY;
    }

    function toggleFixedState () {
        if (!isMobile()) {
            buyButtons.classList.remove('fixed');
            preorderLabel?.classList.remove('fixed');
            return;
        }

        const scrollY = window.scrollY;
        const buffer = 20;

        if (scrollY + buffer >= buyButtonsOffsetTop) {
            buyButtons.classList.add('fixed');
            preorderLabel?.classList.add('fixed');
        } else {
            buyButtons.classList.remove('fixed');
            preorderLabel?.classList.remove('fixed');
        }
    }

    setOffset();
    toggleFixedState();

    window.addEventListener('scroll', toggleFixedState);
    window.addEventListener('resize', () => {
        setOffset();
        toggleFixedState();
    });
});
